export const RETRIEVE_SAISINES_REQUEST = 'RETRIEVE_SAISINES_REQUEST';
export const RETRIEVE_SAISINES_RESPONSE = 'RETRIEVE_SAISINES_RESPONSE';
export const RETRIEVE_SAISINES_ERROR = 'RETRIEVE_SAISINES_ERROR';
export const RETRIEVE_SAISINE_REQUEST = 'RETRIEVE_SAISINE_REQUEST';
export const RETRIEVE_SAISINE_RESPONSE = 'RETRIEVE_SAISINE_RESPONSE';
export const CREATE_SAISINE_REQUEST = 'CREATE_SAISINE_REQUEST';
export const CREATE_SAISINE_RESPONSE = 'CREATE_SAISINE_RESPONSE';
export const ADD_CLAIM_TO_SAISINE_REQUEST = 'ADD_CLAIM_TO_SAISINE_REQUEST';
export const REMOVE_CLAIM_FROM_SAISINE_REQUEST = 'REMOVE_CLAIM_FROM_SAISINE_REQUEST';
export const DELETE_SAISINE_REQUEST = 'DELETE_SAISINE_REQUEST';
export const DELETE_SAISINE_RESPONSE = 'DELETE_SAISINE_RESPONSE';
export const VALIDATE_SAISINE_REQUEST = 'VALIDATE_SAISINE_REQUEST';
export const SEARCH_ELIGIBLE_CLAIMS_REQUEST = 'SEARCH_ELIGIBLE_CLAIMS_REQUEST';
export const SEARCH_ELIGIBLE_CLAIMS_RESPONSE = 'SEARCH_ELIGIBLE_CLAIMS_RESPONSE';
export const CLEAR_ELIGIBLE_CLAIMS = 'CLEAR_ELIGIBLE_CLAIMS';
export const GENERATE_SAISINE_DOCS_REQUEST = 'GENERATE_SAISINE_DOCS_REQUEST';
export const GENERATE_SAISINE_DOCS_RESPONSE = 'GENERATE_SAISINE_DOCS_RESPONSE';
export const AUTOFILL_PREVIEW_REQUEST = 'AUTOFILL_PREVIEW_REQUEST';
export const AUTOFILL_PREVIEW_RESPONSE = 'AUTOFILL_PREVIEW_RESPONSE';
export const AUTOFILL_APPLY_REQUEST = 'AUTOFILL_APPLY_REQUEST';
export const AUTOFILL_APPLY_RESPONSE = 'AUTOFILL_APPLY_RESPONSE';
export const CLEAR_AUTOFILL = 'CLEAR_AUTOFILL';
export const ADD_SAISINE_SUCCESS_FLAG = 'ADD_SAISINE_SUCCESS_FLAG';
export const ADD_SAISINE_ERROR = 'ADD_SAISINE_ERROR';
export const DISMISS_SAISINE_FLAG_ERROR = 'DISMISS_SAISINE_FLAG_ERROR';
export const CLEAR_SAISINE_STATE = 'CLEAR_SAISINE_STATE';

export const retrieveSaisines = (search) => ({
  type: RETRIEVE_SAISINES_REQUEST,
  payload: search,
});

export const retrieveSaisinesResponse = (response) => ({
  type: RETRIEVE_SAISINES_RESPONSE,
  payload: response,
});

export const retrieveSaisinesError = (error) => ({
  type: RETRIEVE_SAISINES_ERROR,
  payload: error,
});

export const retrieveSaisine = (id) => ({
  type: RETRIEVE_SAISINE_REQUEST,
  payload: id,
});

export const retrieveSaisineResponse = (saisine) => ({
  type: RETRIEVE_SAISINE_RESPONSE,
  payload: saisine,
});

export const createSaisine = (claimIds) => ({
  type: CREATE_SAISINE_REQUEST,
  payload: claimIds,
});

export const createSaisineResponse = (response) => ({
  type: CREATE_SAISINE_RESPONSE,
  payload: response,
});

export const addClaimToSaisine = (saisineId, claimId) => ({
  type: ADD_CLAIM_TO_SAISINE_REQUEST,
  payload: { saisineId, claimId },
});

export const removeClaimFromSaisine = (saisineId, claimId) => ({
  type: REMOVE_CLAIM_FROM_SAISINE_REQUEST,
  payload: { saisineId, claimId },
});

export const deleteSaisine = (saisineId) => ({
  type: DELETE_SAISINE_REQUEST,
  payload: saisineId,
});

export const deleteSaisineResponse = () => ({
  type: DELETE_SAISINE_RESPONSE,
});

export const validateSaisine = (saisineId) => ({
  type: VALIDATE_SAISINE_REQUEST,
  payload: saisineId,
});

export const searchEligibleClaims = (saisineId, text) => ({
  type: SEARCH_ELIGIBLE_CLAIMS_REQUEST,
  payload: { saisineId, text },
});

export const searchEligibleClaimsResponse = (claims) => ({
  type: SEARCH_ELIGIBLE_CLAIMS_RESPONSE,
  payload: claims,
});

export const clearEligibleClaims = () => ({
  type: CLEAR_ELIGIBLE_CLAIMS,
});

export const generateSaisineDocs = (claimIds) => ({
  type: GENERATE_SAISINE_DOCS_REQUEST,
  payload: claimIds,
});

export const generateSaisineDocsResponse = (response) => ({
  type: GENERATE_SAISINE_DOCS_RESPONSE,
  payload: response,
});

export const autofillPreview = () => ({
  type: AUTOFILL_PREVIEW_REQUEST,
});

export const autofillPreviewResponse = (proposal) => ({
  type: AUTOFILL_PREVIEW_RESPONSE,
  payload: proposal,
});

export const autofillApply = (proposal) => ({
  type: AUTOFILL_APPLY_REQUEST,
  payload: proposal,
});

export const autofillApplyResponse = (report) => ({
  type: AUTOFILL_APPLY_RESPONSE,
  payload: report,
});

export const clearAutofill = () => ({
  type: CLEAR_AUTOFILL,
});

export const addSaisineSuccessFlag = (message) => ({
  type: ADD_SAISINE_SUCCESS_FLAG,
  payload: message,
});

export const addSaisineError = (error) => ({
  type: ADD_SAISINE_ERROR,
  payload: error,
});

export const dismissSaisineFlag = () => ({
  type: DISMISS_SAISINE_FLAG_ERROR,
});

export const clearSaisineState = () => ({
  type: CLEAR_SAISINE_STATE,
});
